import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CanDeactivate } from '@angular/router';
import { ConfirmationDialogComponent } from '@shared/confirmation-dialog/confirmation-dialog.component';
import { LocaleService } from '@shared/services/locale.service';
import { Observable, map } from 'rxjs';

export interface CanComponentDeactivate {
	canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
	providedIn: 'root',
})
export class CanDeactivatePostAdGuard implements CanDeactivate<CanComponentDeactivate> {
	constructor(private dialog: MatDialog, private locale: LocaleService) {}

	private guardCalled = false;

	canDeactivate(component: CanComponentDeactivate): any {
		if (this.guardCalled) {
			this.guardCalled = false;
			return true;
		}

		const CAN_DEACTIVATE = component.canDeactivate();

		if (CAN_DEACTIVATE) {
			const DIALOG_REF = this.dialog.open(ConfirmationDialogComponent, {
				width: '250px',
				height: '120px',
				disableClose: true,
				data: {
					message: this.locale.translations['place-ad']['n162'],
					yes: this.locale.translations['user']['user-ads']['delete-ad']['n89'],
					no: this.locale.translations['user']['user-ads']['delete-ad']['n90'],
				},
			});

			return DIALOG_REF.afterClosed().pipe(
				map((result) => {
					if (!result) {
						return false;
					} else {
						this.guardCalled = true;

						return true;
					}
				})
			);
		} else {
			return true;
		}
	}
}
